export default [
  {
    id: 'LE1',
    title: 'Kleider machen Leute – oder?',
    download: {
      label: 'Lerneinheit 1',
      url: '/downloads/LE1_Kleider-machen-Leute.pdf',
      file: 'LE1_Kleider-machen-Leute.pdf',
    },
    items: [
      { type: 'component', body: 'LE1' },
      {
        type: 'pdf',
        body: 'Die Aussagen als Bilder zum Download',
        url: [
          '/smartboard/images/original/LE1_Markenklamotten_Frage1.jpg',
          '/smartboard/images/original/LE1_Modetrends_Frage2.jpg',
          '/smartboard/images/original/LE1_Masse_absetzen_Frage3.jpg',
          '/smartboard/images/original/LE1_Nicht_leisten_Frage4.jpg',
          '/smartboard/images/original/LE1_Freunde_Frage5.jpg',
          '/smartboard/images/original/LE1_Secondhand_Frage6.jpg',
        ],
        indent: 1,
      },
      { type: 'component', body: 'LE1_2' },
      {
        type: 'image',
        body: 'Ein junger Mann in Turnschuhen und legerer Kleidung: Wird er als sportlich, locker etc. beschrieben?',
        url: '/smartboard/images/original/LE1_TurnschuhMann_Foto.jpg',
        indent: 1,
      },
      {
        type: 'image',
        body: 'Eine Frau im Business-Outfit mit Brille: Wird sie als erfolgreich, intelligent, wohlhabend etc. beschrieben?',
        url: '/smartboard/images/original/LE1_BusinessFrau_Foto.jpg',
        indent: 1,
      },
      { type: 'component', body: 'LE1_3' },
      {
        type: 'pdf',
        body: 'Lassen Sie die SuS zu Hause mithilfe des Arbeitsblattes einen <b>Kleiderschrank-Check</b> durchführen:',
        url: '/downloads/LE1_KleiderschrankCheck_AB.pdf',
        indent: 1,
      },
      { type: 'component', body: 'LE1_4', indent: 1 },
    ],
  },
  {
    id: 'LE2',
    title: 'Vertrauensfragen: Wer redet bei der Kaufentscheidung von Jugendlichen mit?',
    download: {
      label: 'Lerneinheit 2',
      url: '/downloads/LE2_Kaufentscheidung-Influencer.pdf',
      file: 'LE2_Kaufentscheidung-Influencer.pdf',
    },
    items: [
      { type: 'component', body: 'LE2' },
      {
        type: 'pdf',
        body: 'Zeigen Sie anhand des Arbeitsblatts erst alle Optionen, jeder kann erst für sich überlegen, dann folgt eine klasseninterne Umfrage.',
        url: '/downloads/LE2_Mode-Dschungel_AB.pdf',
        indent: 1,
      },
      { type: 'component', body: 'LE2_2', indent: 1 },
      { type: 'component', body: 'LE2_3' },
      {
        type: 'image',
        body: 'Bildmaterial',
        url: [
          '/smartboard/images/original/LE2_Streitfrage_InstagramAuftritte_Frage1.jpg',
          '/smartboard/images/original/LE2_Streitfrage_Verbandsklage_Frage2.jpg',
          '/smartboard/images/original/LE2_Streitfrage_RechtfertigungInfluencerin_Frage3.jpg',
          '/smartboard/images/original/LE2_Streitfrage_UnlautererWettbewerb_Frage4.jpg',
          '/smartboard/images/original/LE2_Streitfrage_StrittigePosts_Frage5.jpg',
        ],
        indent: 1,
      },
      { type: 'component', body: 'LE2_4' },
    ],
  },
  {
    id: 'LE3',
    title: 'Fast Fashion',
    download: {
      label: 'Lerneinheit 3',
      url: '/downloads/LE3_Fast-Fashion.pdf',
      file: 'LE3_Fast-Fashion.pdf',
    },
    items: [
      { type: 'component', body: 'LE3' },
      {
        type: 'pdf',
        body: 'Arbeitsblatt',
        url: '/downloads/L3_Einschaetzungsfragen_AB.pdf',
        indent: 1,
      },
      { type: 'component', body: 'LE3_2', indent: 1 },
      {
        type: 'video',
        body: 'So ungerecht ist Fast Fashion – Was können wir ändern? Ein Experiment (Tagesschau; 2018)',
        url: 'https://www.youtube.com/watch?v=3ArXxezDhMY',
        indent: 1,
      },
      {
        body: 'Tipp: Stoppen Sie den Film bei Minute 3:38 und schauen Sie den Rest des Films, nachdem Sie mit Ihren Schülern die Aufgaben zu den alternativen Handlungsmöglichkeiten (LE 4) durchgeführt haben.',
        indent: 1,
      },
      { type: 'component', body: 'LE3_3' },
      {
        type: 'pdf',
        body: 'Recherchetipps',
        url: '/downloads/L3_Fast_Fashion_Recherchetipps.pdf',
        indent: 1,
      },
      { type: 'component', body: 'LE3_4', indent: 1 },
      { type: 'component', body: 'LE3_5' },
      {
        type: 'pdf',
        body: 'Lebenszyklus Fast Fashion-Produkt',
        url: '/downloads/L3_Lebenszyklus_Fast_Fashion_AB.pdf',
        indent: 1,
      },
      {
        type: 'pdf',
        body: '(Arbeitsblatt mit Lösung hier.)',
        url: '/downloads/L3_Lebenszyklus_Fast_Fashion_Loesungsblatt.pdf',
        indent: 1,
      },
      { type: 'component', body: 'LE3_6', indent: 1 },
      { type: 'component', body: 'LE3_7' },
    ],
  },
  {
    id: 'LE4',
    title: 'Fair Fashion',
    download: {
      label: 'Lerneinheit 4',
      url: '/downloads/LE4_Fair-Fashion.pdf',
      file: 'LE4_Fair-Fashion.pdf',
    },
    items: [
      { type: 'component', body: 'LE4' },
      {
        type: 'pdf',
        body: 'Arbeitsblatt',
        url: '/downloads/LE4_Kampagnenplanung_AB.pdf',
        indent: 1,
      },
      { type: 'component', body: 'LE4_2', indent: 1 },
      {
        type: 'pdf',
        body: 'Schlagworte, Recherchetipps und Umsetzung können Sie je nach Leistungsstand Ihrer SuS vorgeben oder zur freien Wahl lassen.',
        url: '/downloads/LE4_Handlungsalternativen_Recherchetipps.pdf',
        indent: 1,
      },
      { type: 'component', body: 'LE4_2b', indent: 1 },
      { type: 'component', body: 'LE4_3' },
      {
        type: 'link',
        body: 'Fünf Gründe gegen faire Mode – und fünf Argumente, warum sie Schwachsinn sind',
        url: 'https://www.br.de/puls/themen/leben/warum-ich-keine-faire-mode-trage-100.html',
        indent: 1,
      },
      { type: 'component', body: 'LE4_4' },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/data/SOURCES.js